import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  getPortalSuccess,
  getPortalFailed,
  setPortalCurrent,
} from '../actions';
import { PortalActionTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

export function* fetchPortalSettings() {
  const url = `${API_BASE_URL}/organisation/portal`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(getPortalSuccess(response.raw));
    yield put(setPortalCurrent(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Portal: ${response.message}`);
    yield put(getPortalFailed(response.message));
  }
}

export function* getPortalSettings() {
  yield takeEvery(PortalActionTypes.GET_PORTAL, fetchPortalSettings);
}
